import {
  FaFacebookF,
  FaTiktok,
  FaYoutube,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";

const SOCIALS = [
  {
    href: "https://www.instagram.com/vajdin_dino_pirok/profilecard/?igsh=M3ZlbnozaGFsdjBm",
    label: "Instagram",
    Icon: FaInstagram,
  },
  {
    href: "https://www.facebook.com/share/E7AMXBwjfXJYhtCV/?mibextid=LQQJ4d",
    label: "Facebook",
    Icon: FaFacebookF,
  },
  { href: "https://wa.me/message/NMGM4H3DCGB2C1", label: "WhatsApp", Icon: FaWhatsapp },
  {
    href: "https://www.tiktok.com/@vajdin_dino_pirok?_t=8rLOkEZBmG0&_r=1",
    label: "TikTok",
    Icon: FaTiktok,
  },
  { href: "https://youtube.com/@vdptuning?si=QGuE7IO2reV5z18u", label: "YouTube", Icon: FaYoutube },
];

const Footer = () => {
  return (
    <footer className="border-t border-gray-200 bg-white px-4 py-4 text-sm text-gray-500 dark:border-[#2c2c2e] dark:bg-[#161617] dark:text-slate-400 sm:px-6">
      <div className="mx-auto flex max-w-[1500px] flex-wrap items-center justify-between gap-4">
        <a
          href="https://www.evc.de/en/check_evc_license.asp?k=GjDDuek8kp03z6%2fqSy8Ekw%3d%3d"
          target="_blank"
          rel="noopener noreferrer"
          className="shrink-0 opacity-80 transition hover:opacity-100"
        >
          <img
            src="https://www.evc.de/common/check_evc_license_image.asp?k=GjDDuek8kp03z6%2fqSy8Ekw%3d%3d"
            alt="License Check"
            className="h-8 w-auto rounded"
          />
        </a>

        <p className="order-last w-full text-center text-xs sm:order-none sm:w-auto sm:text-sm">
          © 2026 VDP Tuning. All rights reserved.
        </p>

        <div className="flex items-center gap-2">
          {SOCIALS.map(({ href, label, Icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              title={label}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 text-gray-500 transition hover:border-red-400/60 hover:text-red-500 dark:border-[#3a3a3d] dark:text-slate-400 dark:hover:text-orange-400"
            >
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
